import { useNavigate } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { Container } from "../public/kit";
import { track } from "@/lib/analytics";

const PRO_BENEFITS = ["Get local job opportunities", "No lead fees", "No commissions", "No required subscription"];

// Full-bleed campaign section flowing directly on the navy page backdrop.
export const HomeForPros = () => {
  const navigate = useNavigate();
  const goProvider = () => { track("click_signup_as_provider", { cta: "home-for-pros" }); navigate("/app/auth?mode=signup&role=provider"); };

  return (
    <section className="relative py-14 md:py-24 overflow-hidden bg-[var(--b2-navy-deep)]" data-testid="home-for-pros">
      <div className="pointer-events-none absolute top-0 right-0 w-[560px] h-[560px] rounded-full bg-[radial-gradient(circle,rgba(22,163,74,0.16),transparent_60%)]" />
      <Container>
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center relative">
          <div className="relative order-2 lg:order-1" data-testid="for-pros-image">
            <div className="pointer-events-none absolute -bottom-5 -left-5 w-36 h-36 rounded-[44px] bg-[var(--b2-green)]/15 rotate-6 hidden lg:block" />
            <div className="relative h-[260px] sm:h-[360px] lg:h-[440px] rounded-[26px] lg:rounded-[34px] rounded-br-[90px] overflow-hidden shadow-[0_32px_80px_rgba(0,0,0,0.4)]">
              <img src="/brand/b2-pro.jpg" alt="A local service professional receiving job opportunities on Brivio" loading="lazy" decoding="async"
                className="absolute inset-0 w-full h-full object-cover" style={{ objectPosition: "center 30%" }} />
            </div>
            <div className="absolute top-6 -right-2 sm:right-6 bg-white rounded-2xl shadow-[0_18px_44px_rgba(0,0,0,0.35)] px-4 py-3 flex items-center gap-2.5" data-testid="pros-float-card">
              <span className="w-9 h-9 rounded-full bg-[var(--b2-green-soft)] flex items-center justify-center shrink-0">
                <CheckCircle2 className="w-5 h-5 text-[var(--b2-green)]" />
              </span>
              <span>
                <span className="block font-display font-extrabold text-sm text-[var(--b2-navy)] leading-tight">Local jobs</span>
                <span className="block text-xs text-[var(--b2-ink-soft)]">Near your area</span>
              </span>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <span className="inline-flex rounded-full bg-white/10 text-[#86EFAC] text-xs font-bold uppercase tracking-[0.14em] px-3.5 py-1.5">For Pros</span>
            <h2 className="font-display text-[36px] md:text-[52px] font-extrabold tracking-[-0.02em] leading-[1.05] text-white mt-5">
              Grow your business<span className="block text-[#4ADE80]">with Brivio</span>
            </h2>
            <div className="mt-7 flex flex-col gap-3.5">
              {PRO_BENEFITS.map((b, i) => (
                <span key={b} data-testid={`pro-benefit-${i}`} className="inline-flex items-center gap-3 text-white/90 font-medium text-base">
                  <CheckCircle2 className="w-[22px] h-[22px] text-[#4ADE80] shrink-0" /> {b}
                </span>
              ))}
            </div>
            <button onClick={goProvider} data-testid="for-pros-cta" data-cta="hero-choice-provider"
              className="mt-9 inline-flex items-center justify-center gap-2.5 bg-[var(--b2-green)] text-white hover:bg-[var(--b2-green-hover)] rounded-[18px] px-9 py-[17px] font-display font-extrabold text-[17px] tracking-wide shadow-[0_14px_40px_rgba(22,163,74,0.45)] transition-all duration-200 hover:-translate-y-0.5 w-full sm:w-auto">
              Join as a Pro <ArrowRight className="w-5 h-5" />
            </button>
          </div>
        </div>
      </Container>
    </section>
  );
};
